import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "nt-theme";
const isDark = () => document.documentElement.classList.contains("dark");
const apply = (t) => { document.documentElement.classList.toggle("dark", t === "dark"); window.dispatchEvent(new Event("nt-theme")); };
apply(localStorage.getItem(KEY) === "dark" ? "dark" : "light");

export function ThemeToggle({ className = "" }) {
  const [dark, setDark] = useState(isDark);
  useEffect(() => { const h = () => setDark(isDark()); window.addEventListener("nt-theme", h); return () => window.removeEventListener("nt-theme", h); }, []);
  const flip = () => { const t = isDark() ? "light" : "dark"; localStorage.setItem(KEY, t); apply(t); };
  return (
    <button type="button" role="switch" aria-checked={dark} aria-label="Toggle dark mode" onClick={flip} data-testid="theme-toggle"
      className={`relative inline-flex h-8 w-14 shrink-0 items-center rounded-full border border-[#E2E8ED] bg-[#F7F9FA] transition-colors ${className}`}>
      <span className={`absolute left-1 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow transition-transform duration-300 ${dark ? "translate-x-6" : ""}`}>
        {dark ? <Moon className="h-3.5 w-3.5 text-[#8B7CFF]" /> : <Sun className="h-3.5 w-3.5 text-[#FF9700]" />}
      </span>
    </button>
  );
}
